import * as React from "react";
const Loader = require("react-loader-spinner").default;
//import { toast } from "react-toastify";
import "./Campaign.css";
import Header from "./Header";
import Stats from "./Stats"
export default class Campaign extends React.Component<any, any> {

  constructor(props: any) {
    super(props);
    this.state = {
      campaign: null,
      user:null,
      loading: false,
    };
  }


  loadCampaign = () => {
    fetch(`campaigns/get`, {
      method: "POST",
      body: JSON.stringify({
        id: this.props.match.params.id,
        userId: this.props.match.params.userId
      })
    })
      .then((results) => {
        return results.json();
      })
      .then((data) => {
        this.setState({ campaign: data.campaign });
      })
      .catch((err) => {
        //toast.error(err.message);
      });
  };


  loadUser = () => {
    fetch(`users/get`, {
      method: "POST",
      body: JSON.stringify({id: this.props.match.params.userId})
    })
      .then((results) => {
        return results.json();
      })
      .then((data) => {
        this.setState({ user: data.user });
      })
      .catch((err) => {
        //toast.error(err.message);
      });
  };



  componentDidMount() {
    this.loadCampaign();
    if(this.props.match.params.userId) {
      this.loadUser()
    }

  }






  public render() {
    const {campaign,user} = this.state
    return (
      <div id="users-root">
        {this.state.loading && (
          <div className="loading">
            <Loader
              type="Oval"
              className="loader"
              color="#2f98e0"
              height={100}
              width={100}
            />
          </div>
        )}
        <Header campaign={campaign} user={user} activeTab={"sales"} openMenu={this.props.openMenu} />
        <Stats campaign={campaign} user={user} />

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/campaign/Campaign.tsx